// extracted by mini-css-extract-plugin
module.exports = {"addSubscriptionSection":"subscriptionSelector_addSubscriptionSection__3RELG","addAnotherButton":"subscriptionSelector_addAnotherButton__3qTYF"};